module.exports = __webpack_public_path__ + "img/nav_img_04.ff624239.jpg";